<script setup>
import { reactive, ref } from "vue";
import { useHttp } from "vutil";

const props = defineProps(["email"]);
const emit = defineEmits(["login"]);

const verify = ref(false);
const data = reactive({ email: props.email });

const { busy, error, post } = useHttp(() => {
	if (!verify.value)
		verify.value = true;
	else
		emit("login");
}, () => {
	verify.value = false;
	data.code = null;
});
</script>

<template>
	<h1>Nytt passord</h1>
	<form @submit.prevent="post('/api/user/passwd', data)">
		<fieldset :disabled="busy">
			<template v-if="!email">
				<label for="email">E-postadresse</label>
				<input id="email" v-model.trim="data.email" type="email" autocomplete="username" :readonly="verify" required>
			</template>
			<label for="password">Nytt passord</label>
			<input id="passwd" v-model="data.passwd" type="password" autocomplete="new-password" minlength="8" required>
			<template v-if="verify">
				<label for="code">Verifikasjonskode</label>
				<input id="code" v-model="data.code" type="text" autocomplete="one-time-code" required>
				<div class="ui-hint">Vi har sendt deg en verifikasjonskode på e-post.</div>
			</template>
			<div class="error">{{ error }}</div>
			<button type="submit" class="ui">{{ error ? "Prøv igjen" : verify ? "Verifiser" : "Videre" }}</button>
		</fieldset>
	</form>
</template>
